var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ButtonComponent',{staticClass:"SupportMessengerButton",attrs:{"buttonStyle":"outline"},on:{"click":_vm.showIntercomMessenger}},[_c('MessageIcon',{staticClass:"SupportMessengerButton__icon"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }